export type RuntimeConfig = {
  mode: 'dev' | 'prod';
  gaMeasurementId: string;
};

const measurementIdPattern = /^G-[A-Z0-9]+$/i;

function clean(value: unknown): string {
  if (typeof value !== 'string') return '';
  return value.trim().replace(/^(['"])(.*)\1$/, '$2').trim();
}

export function normalizeRuntime(input: unknown): RuntimeConfig {
  const value = input && typeof input === 'object' ? input as Record<string, unknown> : {};
  const mode = clean(value.mode).toLowerCase() === 'prod' ? 'prod' : 'dev';
  const candidate = clean(value.gaMeasurementId).toUpperCase();
  return { mode, gaMeasurementId: measurementIdPattern.test(candidate) ? candidate : '' };
}

export function getRuntime(): RuntimeConfig {
  const runtime = (globalThis as typeof globalThis & { __BURNOUT_RUNTIME__?: unknown }).__BURNOUT_RUNTIME__;
  return normalizeRuntime(runtime);
}
